import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal/Modal";
import styles from "./CrmUpgradeCta.module.css";

const CRM_TITLE = "Desbloqueie a Central de Atendimento";
const CRM_TEXT =
  "Filas, setores, atribuição de conversas, tags e notas internas fazem parte do plano Profissional. Continue respondendo às conversas normalmente e faça upgrade para atender em equipe.";
const CRM_CTA = "Mudar para o Profissional";

/**
 * Faixa de upgrade exibida no topo do inbox para tenants do plano Básico
 * (`crmIncluded` falso). Espelha o visual dos gates de Leads/Relatórios: acento
 * da marca, linguagem humana, botão para a grade de planos. Nunca é um erro —
 * é um convite.
 */
export function CrmUpgradeBanner({ upgradeUrl = "/subscription/plans" }) {
  const navigate = useNavigate();
  return (
    <div className={styles.banner} role="region" aria-label="Upgrade da Central de Atendimento">
      <span className={styles.icon} aria-hidden="true">
        🚀
      </span>
      <div className={styles.copy}>
        <strong className={styles.title}>{CRM_TITLE}</strong>
        <p className={styles.text}>
          Atenda em equipe com filas, setores, atribuição, tags e notas internas.
        </p>
      </div>
      <button
        type="button"
        className={styles.btn}
        onClick={() => navigate(upgradeUrl)}
      >
        {CRM_CTA}
      </button>
    </div>
  );
}

CrmUpgradeBanner.propTypes = {
  upgradeUrl: PropTypes.string,
};

/**
 * Modal de upgrade — mostrado como defesa em profundidade quando o backend
 * responde 403 `FEATURE_NOT_INCLUDED` a uma ação de equipe que escapou do gate
 * de UI. Reaproveita o `Modal` base; nunca expõe o erro técnico.
 */
export function CrmUpgradeModal({ open, onClose, upgradeUrl = "/subscription/plans" }) {
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <Modal isOpen onClose={onClose} width="420px" titleId="crm-upgrade-title">
      <div className={styles.modal}>
        <span className={styles.icon} aria-hidden="true">
          🔒
        </span>
        <h2 id="crm-upgrade-title" className={styles.modalTitle}>
          {CRM_TITLE}
        </h2>
        <p className={styles.modalText}>{CRM_TEXT}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.btn}
            onClick={() => navigate(upgradeUrl)}
          >
            {CRM_CTA}
          </button>
          <button
            type="button"
            className={styles.btnSecondary}
            onClick={onClose}
          >
            Agora não
          </button>
        </div>
      </div>
    </Modal>
  );
}

CrmUpgradeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  upgradeUrl: PropTypes.string,
};
